<template>
  <div class="container">
    <div class="add-btn">
      <el-button type="primary" @click="addActivity()">新建首页弹窗</el-button>
    </div>
    <div>
      <qy-table
        :table-data="tableData"
        :columns="columns"
        v-loading="tableLoading"
      >
        <!-- 图片列 -->
        <template v-slot:imageSlot="scope">
          <el-image
            class="activity-thumb"
            :src="scope.row.url"
            :preview-src-list="[scope.row.url]"
            fit="cover"
          >
          </el-image>
        </template>
        <!-- 开关列 -->
        <template v-slot:switchSlot="scope">
          <el-switch
            v-model="scope.row.status"
            @change="handleStatusChange(scope.row)"
          ></el-switch>
        </template>
      </qy-table>
    </div>

    <!-- 添加&编辑一体弹窗 -->
    <activity-dialog
      :visible.sync="dialogVisible"
      :row-data="currentRow"
      @submit="handleDialogSubmit"
    />
  </div>
</template>

<script>
import {
  list,
  addActivityPicture,
  getActivityPictureList,
  getActivityPictureDetail,
  updateActivityPicture,
  deleteActivityPicture,
  updateActivityPictureStatus,
} from "@/common/api";
import QyTable from "@/components/qy-table";
import ActivityDialog from "./common/activity-dialog.vue";

export default {
  name: "activity",
  components: {
    QyTable,
    ActivityDialog,
  },
  data() {
    return {
      dialogVisible: false,
      currentRow: null,
      tableLoading: false,
      tableData: [],
    };
  },
  computed: {
    columns() {
      return [
        { label: "图片", prop: "url", slotName: "imageSlot" },
        { label: "时间", prop: "date" },
        {
          label: "是否展示",
          prop: "status",
          slotName: "switchSlot",
          width: "120",
        },
        {
          label: "操作",
          type: "action",
          width: "120",
          actions: [
            { label: "编辑", action: (row) => this.handleEdit(row) },
            { label: "删除", action: (row) => this.handleDelete(row) },
          ],
        },
      ];
    },
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      getActivityPictureList({
        pageNo: 1,
        pageSize: 999,
      })
        .then((res) => {
          if (res.code === 0 && res.data) {
            this.tableData = (res.data.records || []).map((item) => ({
              id: item.id,
              url: item.imageUrl,
              status: item.status === 1,
              date: `${this.formatTime(item.startTime)}-${this.formatTime(
                item.endTime,
              )}`,
              startTime: item.startTime,
              endTime: item.endTime,
              imageUrl: item.imageUrl,
            }));
          } else {
            this.tableData = [];
          }
        })
        .catch((err) => {
          console.error("获取活动列表失败:", err);
          this.tableData = [];
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    formatTime(time) {
      if (!time) return "";
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}.${month}.${day}`;
    },
    addActivity() {
      this.currentRow = null;
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.tableLoading = true;
      getActivityPictureDetail(row.id)
        .then((res) => {
          if (res.code === 0 && res.data) {
            const data = res.data;
            this.currentRow = {
              id: data.id,
              url: data.imageUrl,
              status: data.status === 1,
              date: `${this.formatTime(data.startTime)}-${this.formatTime(
                data.endTime,
              )}`,
              startTime: data.startTime,
              endTime: data.endTime,
              imageUrl: data.imageUrl,
            };
            this.dialogVisible = true;
          } else {
            this.$message.error(res.msg || "获取详情失败");
          }
        })
        .catch((err) => {
          console.error("获取活动详情失败:", err);
          this.$message.error("获取详情失败，请重试");
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleDelete(row) {
      this.$confirm("确定删除该活动通知吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.tableLoading = true;
          deleteActivityPicture(row.id)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success("删除成功");
                this.getList();
              } else {
                this.$message.error(res.msg || "删除失败");
              }
            })
            .catch((err) => {
              console.error("删除活动失败:", err);
              this.$message.error("请求失败，请稍后重试");
            })
            .finally(() => {
              this.tableLoading = false;
            });
        })
        .catch(() => {});
    },
    handleStatusChange(row) {
      const targetStatus = row.status ? 1 : 0;
      updateActivityPictureStatus(row.id, targetStatus)
        .then((res) => {
          if (res.code === 0) {
            this.$message.success("状态修改成功");
          } else {
            this.$message.error(res.msg || "修改失败");
            row.status = !row.status; // 失败回滚
          }
        })
        .catch((err) => {
          console.error("修改状态失败:", err);
          this.$message.error("修改失败，请重试");
          row.status = !row.status; // 异常回退
        });
    },
    handleDialogSubmit(formData, callback) {
      if (formData.id !== undefined) {
        // 编辑保存
        const startTime = new Date(
          formData.dateRange[0].replace(/\./g, "/") + " 00:00:00",
        ).getTime();
        const endTime = new Date(
          formData.dateRange[1].replace(/\./g, "/") + " 23:59:59",
        ).getTime();
        const params = {
          imageUrl: formData.url,
          status: formData.status ? 1 : 0,
          startTime,
          endTime,
        };
        updateActivityPicture(formData.id, params)
          .then((res) => {
            if (res.code === 0) {
              this.$message.success("编辑成功");
              this.getList(); // 刷新列表
              callback(true);
            } else {
              this.$message.error(res.msg || "保存失败");
              callback(false);
            }
          })
          .catch((err) => {
            this.$message.error("请求失败，请稍后重试");
            callback(false);
          });
      } else {
        // 新建保存
        const startTime = new Date(
          formData.dateRange[0].replace(/\./g, "/") + " 00:00:00",
        ).getTime();
        const endTime = new Date(
          formData.dateRange[1].replace(/\./g, "/") + " 23:59:59",
        ).getTime();
        const params = {
          imageUrl: formData.url,
          status: formData.status ? 1 : 0,
          startTime,
          endTime,
        };
        addActivityPicture(params)
          .then((res) => {
            if (res.code === 0) {
              this.$message.success("新增成功");
              this.getList(); // 新增成功后重新加载列表
              callback(true);
            } else {
              this.$message.error(res.msg || "保存失败");
              callback(false);
            }
          })
          .catch((err) => {
            this.$message.error("请求失败，请稍后重试");
            callback(false);
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  .add-btn {
    padding: 10px 0;
  }
}
.activity-thumb {
  width: 48px;
  height: 48px;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  background-color: #f5f7fa;
}
</style>
